import { JobRecruitResponse } from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import {
  createBonusText,
  createRaiseText,
} from '@doda/common/src/logics/jobSearchDetail/salary';
import { addComma } from '@doda/common/src/utils/convNumberUtil';
import { VisibleAnalytics } from '@doda/common/src/components/Analytics/VisibleAnalytics';
import { measureVisibleSalary } from 'pages/DodaFront/View/JobSearchDetail/logics/analytics';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { SubSection } from '../../SubSection';
import styles from './index.module.scss';
import { SectionItem } from '../../SectionItem';

/**
 * SalaryのProps
 */
interface Props {
  recruit: JobRecruitResponse;
}

/**
 * 給与(A,B,C,D,E原稿)
 */
export const Salary = ({ recruit }: Props) => {
  const dispatch = useAppDispatch();
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  const {
    salary,
    incentive,
    numberOfBonuses,
    bonus,
    numberOfSalaryIncrease,
    raise,
    estimatedAnnualIncomes = [],
    salaryExamples = [],
  } = recruit;
  const bonusText = createBonusText(numberOfBonuses, bonus);
  const raiseText = createRaiseText(numberOfSalaryIncrease, raise);
  const hasEstimatedAnnualIncomes = estimatedAnnualIncomes.length !== 0;
  const hasSalaryExamples = salaryExamples.length !== 0;
  if (
    !salary &&
    !incentive &&
    !bonusText &&
    !raiseText &&
    !hasEstimatedAnnualIncomes &&
    !hasSalaryExamples
  )
    return null;

  return (
    <SectionItem label="給与">
      <VisibleAnalytics
        onVisible={() => measureVisibleSalary(isAdobeScript, dispatch)}
      >
        {salary && (
          <div className={styles['jobSearchDetail-salary__detail']}>
            <TextWithLF text={salary} />
          </div>
        )}
        <div className={styles['jobSearchDetail-salary__items']}>
          {incentive && (
            <SubSection label="給与にプラスしてもらえる手当・インセンティブ">
              <TextWithLF text={incentive} />
            </SubSection>
          )}
          {bonusText && (
            <SubSection label="賞与">
              <TextWithLF text={bonusText} />
            </SubSection>
          )}
          {raiseText && (
            <SubSection label="昇給">
              <TextWithLF text={raiseText} />
            </SubSection>
          )}
          {hasEstimatedAnnualIncomes && (
            <SubSection label="入社時の想定年収">
              {estimatedAnnualIncomes?.map(({ income, incomeExplanation }) => {
                if (!income) return null;
                const estimatedAnnualIncomeText = `年収${addComma(income)}万円${
                  incomeExplanation ?? ''
                }`;
                return (
                  <Text size="14--articlePC" key={estimatedAnnualIncomeText}>
                    {estimatedAnnualIncomeText}
                  </Text>
                );
              })}
            </SubSection>
          )}
          {hasSalaryExamples && (
            <SubSection label="社員の年収例">
              <Text size="14--articlePC">
                {salaryExamples?.map(({ text }) => (
                  <TextWithLF key={text} text={text ?? ''} />
                ))}
              </Text>
            </SubSection>
          )}
        </div>
      </VisibleAnalytics>
    </SectionItem>
  );
};
